import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { label: "Worlds", to: "/#worlds", id: "worlds" },
  { label: "Features", to: "/#features", id: "features" },
  { label: "Pricing", to: "/#pricing", id: "pricing" },
  { label: "App", to: "/#app", id: "app" },
  { label: "Support", to: "/#support", id: "support" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="fixed inset-x-0 top-0 z-50 border-b border-slate-200/60 bg-white/70 backdrop-blur-xl"
      data-testid="navbar"
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5 sm:px-8">
        <Link to="/" aria-label="ORIVA AI home" data-testid="nav-logo-link">
          <Logo />
        </Link>

        <nav className="hidden items-center gap-8 md:flex" data-testid="nav-links">
          {links.map((link) => (
            <Link
              key={link.id}
              to={link.to}
              data-testid={`nav-link-${link.id}`}
              className="text-sm font-medium text-slate-600 transition-colors duration-200 hover:text-slate-900"
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:block">
          <Link
            to="/#app"
            data-testid="nav-cta-get-oriva"
            className="inline-flex items-center gap-1.5 rounded-full bg-oriva-blue px-5 py-2.5 text-sm font-medium text-white transition-colors duration-200 hover:bg-blue-700"
          >
            Get ORIVA
            <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>

        <button
          className="grid h-10 w-10 place-items-center rounded-lg border border-slate-200 text-slate-700 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.25, ease: "easeOut" }}
            className="overflow-hidden border-t border-slate-200/60 bg-white/95 backdrop-blur-xl md:hidden"
            data-testid="nav-mobile-menu"
          >
            <div className="flex flex-col gap-1 px-5 py-4">
              {links.map((link) => (
                <Link
                  key={link.id}
                  to={link.to}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-link-${link.id}`}
                  className="rounded-lg px-3 py-3 text-sm font-medium text-slate-700 transition-colors duration-200 hover:bg-slate-50"
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/#app"
                onClick={() => setOpen(false)}
                data-testid="nav-mobile-cta-get-oriva"
                className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-full bg-oriva-blue px-5 py-3 text-sm font-medium text-white"
              >
                Get ORIVA
                <ArrowUpRight className="h-4 w-4" />
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
